import { Product } from "../products/product";
import { Duty } from "../calculator/duty";
import { Country } from "../management/locationManagement/Country";
import { CanadianCurrencyCode } from "../currencyExchange/canadianCurrencyCode";
import { OrderTotal } from "./orderTotal";
import { PdaType } from "./PdaType";
import { CurrencyEnum } from "../currencyExchange/currencyEnum";
import { OrderItemOptions } from "./orderItemOptions";
import { TaxType } from "./taxType";

/**
 * Created by alex.y on 8/8/2017.
 */
export class OrderItem {
    public Id: string;
    public Price: number;
    public Currency: CurrencyEnum = CurrencyEnum.FXUSDCAD;
    public Product: Product = new Product();
    public DutyList: Duty[] = [];
    public Manufacturer: Country = new Country();
    public CanadianCurrencyCode: CanadianCurrencyCode = new CanadianCurrencyCode();
    public Total: OrderTotal = new OrderTotal();
    public Type: PdaType;
    public IsPurchased: boolean = false;
    public IsAgentEditCustomDuty: boolean = false;
    public AgentEditedCustomDutyPercent: number;
    public OrderId: number;
    public FirstNumber: number;
    public Flags: OrderItemOptions;
    public Year: number;
    public CurrencyId: number;
    public Taxes: ItemTax[] = [];

    // public GreenLevy: GreenLevyType;

    constructor(obj?: Partial<OrderItem>) {
        Object.assign(this, obj);
    }
}

export enum GreenLevyType {
    from0to13 = 0,
    from13to14,
    from14to15,
    from15to16,
    more16
}

export class ItemTax {
    public Id: number;
    public ItemId: string;
    public TaxType: TaxType;
    public Value: number;
    public Created: Date;
    public Updated: Date;

    constructor(obj?: Partial<ItemTax>) {
        Object.assign(this, obj);
    }
}


// WEBPACK FOOTER //
// ./app/objects/orders/orderItem.ts